module.exports = __webpack_public_path__ + "assets/img/King Albert Park MRT Interchange.d6fa3855.jpg";